<template>
  <div v-if="loading" class="preview-multi-select">
    <b>Tags:</b> <span>Selecione</span>
  </div>
  <MultiSelect
    v-else
    label="Tags"
    :campos="tags"
    :filtro="filtro"
    :filtro_id="filtro.filtro"
    :path="path"
    @atualizar="atualizar"
  />
</template>

<script>
import Multiselect from '../../mixins/Multiselect.js';

export default {
  mixins: [Multiselect],
  props: {
    modelosPermitidos: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      tags: [],
      loading: true
    }
  },
  mounted() {
    this.$api.get('/custom_tags', { params: { modelos_permitidos: this.modelosPermitidos } }).then(response => {
      this.tags = response.data.tags.map(tag => ({
        id: tag.id,
        name: tag.name
      }));

      this.loading = false;
    })
  }
}
</script>